module.exports = __webpack_public_path__ + "static/img/clause_confirmation133.8fe2bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation133.png
// module id = tS4N
// module chunks = 1